import { Grid, Stack, Typography, ButtonGroup } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { OrganisationContext } from "../components/Layout/OrganisationPicker";
import { CreateDNSButton } from "../feature/DnsAPI/CreateDNSButton";
import { TXTRecordList } from "../feature/DnsAPI/txtList";
import { useGetAllRecordsByOrgIdQuery, useGetAllRecordsQuery } from "../feature/DnsAPI/redux/dnsApiSlice";
import Loading from "../components/loading";
import { UserContext } from "../feature/UserApi/logic/FetchUser";

export const DNSPage = () => {
    const { t } = useTranslation()

    const currentOrganisation = useContext(OrganisationContext)?.organisation;
    const userContext = useContext(UserContext);


    if (!currentOrganisation && !userContext?.allowEmptyOrganisation())
        return <Loading />

    return (
        <Grid container spacing={5}>
            <Grid item xs={6}>
                <Stack direction="row" spacing={2}>
                    <Typography variant="h5">DNS</Typography>
                    <ButtonGroup variant="text">
                        <CreateDNSButton />
                    </ButtonGroup>
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h5">{t("TXT Records")}</Typography>
                <TXTRecordList
                    idToFetch={currentOrganisation?.uuid}
                    getRecords={currentOrganisation ? useGetAllRecordsByOrgIdQuery : useGetAllRecordsQuery}
                />

            </Grid>
        </Grid>
    )
}
